/**
 * Splits an array into two separate arrays depending of critera function passed in.
 * Basic implementation of lodash.partion: https://lodash.com/docs/#partition
 */
export const partition = <T>(arr: T[], callback: (item: T) => boolean): T[][] => [
  arr.filter((item) => callback(item)),
  arr.filter((item) => !callback(item)),
];
